import { useMemo } from "react";

import { NavGroup, NavItemProps } from "am-tax-fe-core";

import { useApplications, useNavItems, useNavItemsForProject } from "../../../api/index.ts";
import { EngagementArea } from "../../../auth/Permissions.ts";
import { useProjectAppPermissions } from "../../../hooks/usePermissions.ts";
import { NavArea } from "../../../types/enums/index.ts";

import { getNavItem, NavItemExtended } from "./app-utils.tsx";

export interface ProjectAppItems {
    items: Array<NavGroup | NavItemProps>;
    isLoading: boolean;
    error?: string | undefined;
}

export const useProjectAppItems = (engagementId: string, projectId: string): ProjectAppItems => {
    const { data: navItems, isLoading: isNavItemsLoading } = useNavItems();
    const { data: projectNavItems, isLoading: isProjectNavItemsLoading } = useNavItemsForProject(engagementId, projectId);
    const { data: applications, isLoading: isApplicationsLoading } = useApplications(engagementId, projectId);

    const projectAppPermissions = useProjectAppPermissions(engagementId, projectId, !!projectId);

    const isLoading = isNavItemsLoading || isProjectNavItemsLoading || isApplicationsLoading;

    const projectItems = useMemo(
        () => [...(navItems ?? []).filter(item => item.area === NavArea.Engagement), ...(projectNavItems ?? [])],
        [navItems, projectNavItems],
    );

    const groupList: Array<NavGroup | NavItemProps> = [];

    if (projectAppPermissions.has(EngagementArea.read)) {
        if (projectItems && projectItems.length > 0) {
            const headerGroup: NavGroup = {
                isGroup: true,
                groupColor: "transparent",
                groupMargin: "1rem 0 0 0",
                itemDefaults: { hoverColor: "whiteAlpha.200", activeColor: "blue.400" },
                groupHeading: "Applications",
                items: [],
            };
            groupList.push(headerGroup);
        }

        if (projectItems.length) {
            for (const navItem of projectItems) {
                const groupItem = getNavItem(navItem as NavItemExtended, engagementId, projectId, applications ?? []);
                if (groupItem) {
                    groupList.push(groupItem);
                }
            }
        }
    }

    return { items: groupList, isLoading };
};
